"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Context = _interopRequireDefault(require("./Context"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ProductSelector = function ProductSelector(_ref) {
  var isShowAllFields = _ref.isShowAllFields;
  var _useContext = (0, _react.useContext)(_Context["default"]),
    productList = _useContext.productList,
    selectedProduct = _useContext.selectedProduct,
    selectedCourse = _useContext.selectedCourse,
    selectedDeployment = _useContext.selectedDeployment,
    setSelectedProduct = _useContext.setSelectedProduct,
    setSelectedCourse = _useContext.setSelectedCourse,
    setSelectedDeployment = _useContext.setSelectedDeployment;
  var disabledOption = /*#__PURE__*/_react["default"].createElement("option", {
    value: "-1",
    disabled: true,
    key: "-1"
  }, "-- None to select --");
  var isProductOptions = Array.isArray(productList) && productList.length > 0;
  var isCourseOptions = Array.isArray(selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.assignmentList) && selectedProduct.assignmentList.length > 0;
  var isDeploymentOptions = Array.isArray(selectedCourse === null || selectedCourse === void 0 ? void 0 : selectedCourse.deploymentList) && selectedCourse.deploymentList.length > 0;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].selector
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "product"
  }, "Product:"), /*#__PURE__*/_react["default"].createElement("select", {
    value: (selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.productId) || '-1',
    className: "form-control",
    name: "product",
    onChange: function onChange(event) {
      return setSelectedProduct(productList.find(function (p) {
        return Number(p.productId) === Number(event.target.value);
      }));
    },
    disabled: !isProductOptions
  }, isProductOptions ? productList.map(function (p) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      value: p.productId,
      key: p.productId
    }, p.label);
  }) : [disabledOption]), selectedProduct && /*#__PURE__*/_react["default"].createElement("p", {
    className: "help-block"
  }, /*#__PURE__*/_react["default"].createElement("small", null, /*#__PURE__*/_react["default"].createElement("i", null, selectedProduct.ownedLicenseCount, " license", selectedProduct.ownedLicenseCount === 1 ? '' : 's', " in use")))), isShowAllFields && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "product"
  }, "Course:"), /*#__PURE__*/_react["default"].createElement("select", {
    value: (selectedCourse === null || selectedCourse === void 0 ? void 0 : selectedCourse.assignmentId) || '-1',
    className: "form-control",
    name: "product",
    onChange: function onChange(event) {
      return setSelectedCourse(selectedProduct.assignmentList.find(function (a) {
        return Number(a.assignmentId) === Number(event.target.value);
      }));
    },
    disabled: !isCourseOptions
  }, isCourseOptions ? selectedProduct.assignmentList.map(function (a) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      value: a.assignmentId,
      key: a.assignmentId
    }, a.label);
  }) : [disabledOption])), /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    htmlFor: "product"
  }, "Data Collection Wave:"), /*#__PURE__*/_react["default"].createElement("select", {
    value: (selectedDeployment === null || selectedDeployment === void 0 ? void 0 : selectedDeployment.deploymentId) || '-1',
    className: "form-control",
    name: "product",
    onChange: function onChange(event) {
      setSelectedDeployment(selectedCourse.deploymentList.find(function (d) {
        return Number(d.deploymentId) === Number(event.target.value);
      }));
    },
    disabled: !isDeploymentOptions
  }, isDeploymentOptions ? selectedCourse.deploymentList.map(function (d) {
    return /*#__PURE__*/_react["default"].createElement("option", {
      value: d.deploymentId,
      key: d.deploymentId
    }, d.label);
  }) : [disabledOption]))));
};
var _default = exports["default"] = ProductSelector;